import React, { ReactNode, useContext } from "react";
import { Accordion, AccordionContext, Card, useAccordionButton } from "react-bootstrap";

interface Props {
	children: ReactNode | (() => ReactNode);
	title: string;
	index: number;
	total: number;

	subtitle?: string;
	isActive?: boolean;
	isCompleted?: boolean;
	disabled?: boolean;
	className?: string;
}

const BftAccordion: React.FC<Props> = (props) => {
	const { children, title, className, index, total, isActive, isCompleted, disabled, subtitle } =
		props;

	const getStateClass = () => {
		const baseClass = "state-accordion d-flex justify-content-center align-items-center";
		if (isActive) {
			return `${baseClass} active`;
		}
		if (isCompleted) {
			return `${baseClass} completed`;
		}
		return `${baseClass}`;
	};

	const CustomToggle = ({ eventKey, callback, disabled }: any) => {
		const { activeEventKey } = useContext(AccordionContext);

		const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

		const isCurrentEventKey = activeEventKey === eventKey;

		return (
			<button
				type="button"
				className={`toggle-button ${isCurrentEventKey ? "opened" : "closed"}`}
				onClick={decoratedOnClick}
				disabled={disabled}
			>
				{isCurrentEventKey ? "-" : "+"}
			</button>
		);
	};

	return (
		<Accordion activeKey={isActive ? "0" : undefined} className={`bft-accordion  ${className}`}>
			<Card className="shadow">
				<Card.Header className="d-flex align-items-center justify-content-between me-3">
					<div className="d-flex align-items-center">
						<div className={getStateClass()}>
							{isCompleted && (
								<i className="fas fa-check text-white" style={{ fontSize: "0.7rem" }}></i>
							)}
						</div>
						<h5 className="m-0">{title}</h5>
					</div>

					<div className="d-flex align-items-center">
						<span className="gray counter-accordion">{`${index} di ${total}`}</span>
						<CustomToggle eventKey={"0"} disabled={disabled} />
					</div>
				</Card.Header>

				<span className="gray mx-4">{subtitle}</span>

				<Accordion.Collapse eventKey={"0"}>
					<Card.Body>{typeof children === "function" ? children() : children}</Card.Body>
				</Accordion.Collapse>
			</Card>
		</Accordion>
	);
};
export default BftAccordion;
